<template>
	<v-expansion-panels class="py-2" multiple flat>
		<v-expansion-panel
			v-for="item in items"
			:key="item.idAta"
			class="py-0 my-2"
			active-class="aberto"
			flat
		>
			<v-expansion-panel-header class="collapse-selecionados-header" ripple>
				<div class="collapse-header">
					<slot name="collapse-header" :item="item"></slot>
				</div>
			</v-expansion-panel-header>
			<v-expansion-panel-content class="collapse-selecionados-conteudo">
				<slot name="collapse-content" :item="item">
					<h2>Conteudo do collapse</h2>
				</slot>
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-expansion-panels>
</template>
<script>
export default {
	name: 'collapse-para-listagem',
	props: {
		items: {
			type: Array,
			required: true
		}
	}
}
</script>
<style scoped lang="stylus">
estilo-padrao()
	border .1rem solid var(--v-grey-lighten1)
	border-radius .3rem

.v-expansion-panel--active.aberto > .v-expansion-panel-header
	min-height auto

.aberto .collapse-selecionados-header
	border-bottom-left-radius 0
	border-bottom-right-radius 0

.aberto .collapse-selecionados-conteudo
	border-top-color transparent
	border-top-left-radius 0
	border-top-right-radius 0

.collapse-selecionados-header
	background-color var(--v-grey-lighten4)
	color var(--v-grey-darken1)
	estilo-padrao()

.collapse-selecionados-conteudo
	estilo-padrao()
	padding-top: .5%;

.collapse-header
	display flex
	justify-content flex-start
	align-items center
	gap 10px
</style>
